const CouponAgreementKorean = () => {
  return (
    <>
      <div className="whitespace-nowrap">1.이용 자격 및 이용 절차</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 이용자는 「『GUEST COUPON』이용약관」(이하 '본 약관'이라 합니다.)을 승인한 후, 주식회사 한큐한신백화점 (이하 '당사'라 합니다.) 
        에 이용을 신청하고, 당사가  여권으로 본인 확인 후 면세 자격을 확인하여 면세 대상자임이 확인되면 『GUEST COUPON』(이하 '쿠폰'이라 합니다.)을 발행합니다. 
        <br />
        (2) 쿠폰 이용 시에 여권으로 본인 확인을 하는 경우가 있습니다.
      </div>
      <div className="mt-4">2. 쿠폰의 발행 및 이용</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 쿠폰의 발행은 1인당1회에 한하며, 발행 당일로부터 한큐 우메다 본점, 한신 우메다 본점,  고베 한큐, 한큐 맨즈 오사카, 한큐 맨즈 도쿄 및 하카타 한큐에서 이용할 수 있습니다. 
        <br />
        (2) 쿠폰은 서명 또는 정보를 등록한 본인만 이용할 수 있으며, 양도 및 대여할 수 없습니다. 타인에게 양도 또는 대여한 사실이 판명된 경우, 쿠폰을 무효로 처리하고 재신청을 거절할 경우가 있습니다.
        <br />
        (3) 쿠폰은 디지털 방식으로 발행하는 것을 원칙으로 합니다.
      </div>
      <div className="mt-4">3. 유효 기간</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        쿠폰의 유효기간은 발행일로부터 7일간으로 합니다.
      </div>
      <div className="mt-4">4. 우대</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 당사가 지정한 매장에서 계산 전에 쿠폰을 제시해 주시기 바랍니다. 
        <br />
        (2) 쿠폰을 제시하지 않을 경우 우대이 적용되지 않으므로 주의하시기 바랍니다. 
        <br />
        (3) 계산 후의 영수증 제시로는 우대을 받을 수 없으니 미리 양해해 주시기 바랍니다. 
        <br />
        (4) 쿠폰 이용에 따른 우대는 다른 포인트 카드, 우대 및 혜택 등과의 병용할 수 없습니다. 
        또한, 우대 대상이 아닌 매장이 있습니다. 대상 매장에서도 1,000엔 미만(소비세 제외) 인 상품, 바겐세일 상품, 후쿠부쿠로, 상품권, 식료품, 레스토랑・카페, 일부 매장은 우대 대상에서 제외됩니다.
        <br />
        (5) 우대 내용은 예고 없이 추가, 변경, 종료될 경우가 있습니다.
      </div>
      <div className="mt-4">5. 구매 상품 반품 시의 처리</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        쿠폰을 이용한 구매 상품을 반품할 경우에도 반드시 쿠폰을 제시해 주시기 바랍니다.
      </div>
      <div className="mt-4"> 6. 재발행</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 재발행 시에는 반드시 여권을 지참해 주시기 바랍니다. 
        <br />
        (2) 쿠폰이 재발행되는 시점에 이미 발행된 쿠폰은 실효로 됩니다.
      </div>
      <div className="mt-4">7. 이용 자격의 상실</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        양도, 대여 등 본 약관 위반, 또는 부정행위가 있을 경우 이용 자격을 상실합니다.
      </div>
      <div className="mt-4">8. 본 규약의 추가, 변경</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        본 규약을 변경하는 경우에는 홈페이지 또는 매장 게시 또는 기타 방법으로 미리 변경 내용과 변경일을 공지하고, 다음 각호를 충족하는 경우 해당 변경일로부터 적용됩니다.
        <br />
        (1) 본 규약의 변경이 이용자 일반의 이익에 적합하는 경우. 
        <br />
        (2) 본 규약의 변경이 계약 목적에 반하지 않으며, 변경의 필요성, 변경 후 내용의 상당성에 비추어 합리적인 경우.
      </div>
      <div className="mt-4">9. 쿠폰의 종료</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        당사의 사정에 따라 쿠폰의 취급을 종료하는 경우, 홈페이지 또는 매장 계시 또는 기타 방법으로 미리 종료일을 공지합니다. 이 경우 혜택을 이용할 수 없게 됨에 미리 양해해 주시기 바랍니다.
      </div>
      <div className="mt-4">10. 개인정보의 관리 및 수집</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        당사는 쿠폰의 운영 및 관리에 필요한 다음의 정보(이하 '개인정보'라 합니다.)를 수집합니다.
        <br />
        (1) 이용자 정보(성함, 생년월일, 국적, 거주지, 전화번호, 이메일 주소) 
        <br />
        (2) 쿠폰 이용 내용(이용 점포, 상품명, 이용금액, 이용횟수 등)
      </div>
      <div className="mt-4">11. 개인정보의 이용 목적</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        당사는 10의 규정에 따라 당사가 수집한 이용자의 개인정보를 개인정보 보호조치를 마련 후 보유하며, 다음 목적을 위하여 이용합니다.
        <br />
        (1) 쿠폰의 운영 또는 혜택에 관한 안내를 하기 위해. 
        <br />
        (2) 당사의 행사나 상품, 서비스, 정보등의 각종 안내를 하기 위해.
        <br />
        (3) 시장 조사, 상품 개발, 리뉴얼 등을 위한 마케팅 활동을 위해. 
        <br />
        (4) 쿠폰의 이용 내용에 대한 확인 등의 연락을 하기 위해.
      </div>
      <div className="mt-4">12. H2O 리테일링 그룹 각 사에 대한 개인정보 제공</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        당사는 10의 규정에 따라 당사가 수집한 이용자의 개인정보를 다음과 같은 목적으로 H2O 리테일링 그룹 각사(※)와 공동으로 이용합니다. 
        <br />
        (1) 각사의 행사나 상품, 서비스, 정보 등의 각종 안내를 위해. 
        <br />
        (2) 시장 조사, 상품 개발, 리뉴얼 등을 위한 마케팅 활동을 위해.
        <br />
        ※ H2O 리테일링 그룹 각사란, H2O 리테일링 주식회사 및 다음 URL에 기재된 각사 [https://www.h2o-retailing.co.jp/ja/company/group.html]를 의미합니다.
        <br />
        공동으로 이용되는 개인 데이터의 관리에 대한 책임은 당사(https://www.hankyu-hanshin-dept.co.jp/profile.html)에 있습니다.
      </div>

      <div className="mt-4">
        13.개인정보 공개, 정정, 삭제, 이용 또는 제공 중단 청구 등 이용자에 의한 권리 행사
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        이용자가 정당한 이유로 당사 소정의 절차에 따라 자신의 개인정보에 대한 공개, 정정, 삭제, 개인정보의 이용 또는 제공 중단 청구 등 적용되는 법령에서 인정되는 권리 행사 청구를 한 경우, 당사는 원칙적으로 이에 응합니다. 
        다만, 이 경우에도 당사는 적용되는 법령에서 인정되는 범위 내에서 쿠폰 관리, 문의 대응 등 본 쿠폰의 운영, 관리를 위해 필요한 목적의 범위 내에서 개인정보의 이용 및 제공 등을 계속할 수 있습니다.
      </div>
      <div className="mt-4">
        14. 개인정보 공개, 정정, 삭제, 이용 또는 제공 중단 청구 등의 청구 방법
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        이용자는 자신에 관한 개인정보의 공개를 청구하는 경우, 당사 소정의 신청서에  필요 사항을 기입한 후 여권 등 본인임을 증명할 수 있는 서류와 함께 당사에 제출해야 합니다. 
        또한, 신청서 제출부터 정보 공개 등에 대한 대응까지 상당한 시간이 걸릴 수 있습니다. 또한, 이러한 청구를 할 때 적용되는 법령에서 인정되는 범위 내에서 미리 소정의 수수료가 들 수 있습니다.
      </div>
      <div className="mt-4">15. 개인정보 취급에 대한 부동의 </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 이용자의 개인정보 제공은 쿠폰의 운영, 관리 및 계약 이행에 필요한 요건이며, 이용자가 쿠폰을 이용하기 위해서는 본 약관에 동의한 후에 10의 규정에서 정한 필요한 개인정보를 제공해야 합니다. 
        <br />
        (2) 이용자는 개인정보를 제공할 의무는 없으나, 본 약관에 동의하지 않거나 쿠폰의 운영, 관리에 필요한 개인정보의 제공을 거부한 경우, 당사는 쿠폰 발행을 거절할 수 있습니다.
      </div>
      <div className="mt-4">16. 개인정보 보관 기간 </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        (1) 당사는 취득한 개인정보에 대해 그 처리 목적에 따라 필요 최소한의 보관 기간을 설정하고, 해당 기간 내에 한해 보관합니다. 보관 기간의 결정 시에는 관련 법령을 토대로 한 의무, 계약의 이행에 필요한 기간을 고려합니다. 
        <br />
        (2) 보관할 필요가 없어진 개인정보는 적절한 방법으로 신속하게 폐기합니다.
      </div>
      <div className="mt-4">17. 개인정보 관리자 및 연락처</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        본 쿠폰의 운영 및 관리 시 수집되는 개인정보의 관리자 및 연락처는 아래와 같습니다.
        <br />
        관리자: 주식회사 한큐한신 백화점
        <br />
        연락처: 본 약관 내 ‘문의처’
      </div>
      <div className="mt-4">
        18. EEA 또는 영국 거주 이용자의 개인 데이터에 관한 특례
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        1. 이용자의 개인 데이터는 아래와 같은 법적 근거를 토대로 취급합니다.
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) 쿠폰 운영이나 특전에 관한 안내를 위해.(‘계약 이행’) 
        <br />
        (2) 당사의 행사나 상품, 서비스, 정보 등 다양한 안내를 위해.(‘정당한 이익’)
        <br />
        (3) 시장 조사, 상품 개발, 리뉴얼 등을 위한 마케팅 활동을 위해.(‘정당한 이익’) 
        <br />
        (4) 쿠폰의 이용 내용 확인 등 연락을 위해.(‘계약 이행’)
        <br />
        (5) 적용 법률 준수, 법원 명령 및 법적 절차에 대응하기 위해, 또는 당사의 법적 주장을 입증하거나 공격 또는 방어하기 위해.(‘정당한 이익’)
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        2. 이용자는 아래와 같은 권리를 가집니다. 이용자는 아래 19에 기재된 당사의 연락처로 연락함으로써 해당 권리를 행사할 수 있습니다. 
        또한, 당사에 의해 권리가 침해되었다고 판단하는 경우에는 관련 데이터 보호 당국에 불만을 제기할 수도 있습니다.
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) 이용자에 관한 개인 데이터의 처리 관련 정보를 취득할 권리 및 이용자에 대해 당사가 보유한 개인 데이터에 접근할 권리 
        <br />
        (2) 이용자의 개인 데이터가 부정확하거나 불완전한 경우, 당사에 대해 정정을 요구할 권리
        <br />
        (3) 특정 상황에서 개인 데이터의 삭제를 당사에 요구할 권리 
        <br />
        (4) 특정 상황에서 당사의 개인 데이터 처리를 제한하도록 당사에 요구할 권리
        <br />
        (5) 개인 데이터 처리와 관련하여 당사에 이의를 제기할 권리
        <br />
        (6) 구조화되고 일반적으로 사용되며 기계 가독성이 있는 형식으로 개인 데이터를 수신하는 것, 및/또는 당사가 기술적으로 가능한 범위 내에서 수령자에게 개인 데이터를 직접 이전하는 것을 요구할 권리 
        <br />
        (7) 개인 데이터의 처리가 동의에 기반한 경우, 해당 동의를 언제든지 철회할 권리(단, 동의의 철회는 철회 전까지 이루어진 개인 데이터 처리의 적법성에 영향을 미치지 않습니다.)
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        3. 이용자의 개인 데이터는 EEA 역외 또는 영국 외의 제3자에게 이전될 수 있습니다. 
        당사가 개인 데이터를 EEA 지역 외 또는 영국 외의 제3자에게 이전하는 경우, 아래 중 하나를 확보합니다. 또한, 이용자는 19에 기재된 당사의 연락처로 연락함으로써 개인 데이터가 EEA 역외 또는 영국 외로 이전될 경우 제공되는 보호조치에 대한 추가 세부 사항을 확인할 수 있습니다.
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) 이전처가 되는 국가나 지역이 이용자가 개인 데이터에 대해 가지는 권리 및 자유에 대해 충분한 수준의 보호를 확보하고 있는 국가 또는 지역으로 유럽위원회 또는 영국 정부로부터 지정을 받은 경우. 
        <br />
        (2) 제3자가 유럽위원회 또는 영국 정부로부터 승인받은 표준 데이터 보호 조항을 당사와 체결한 경우.
      </div>
      <div className="mt-4">19. 문의처</div>
      <div className="self-start mt-2 ml-4 text-xs font-light leading-5">
        쿠폰에 관한 문의, 연락 등은 다음 연락처로 연락 주시기 바랍니다.
        <br />
        한큐한신백화점 해외 고객 카운터
        <br />
        {"https://service.hankyu-hanshin-dept.co.jp/inquiry_ko/"}
        <br />
        전화 번호 0081-6-6361-1381
        <br />
        접수 시간 오전 10시부터 오후 6시까지(일본 시간)
        <br />
           ※1. 본 약관을 읽고 동의하신 후 신청해 주시기 바랍니다.
        <br />
           ※2. 본 약관은 일본어로 작성된 것을 정식으로 하며, 일본법에 준거하여 해석 및 운용되는 것으로 합니다. 또한,   일본어 이외의 언어로 표기된 것은 번역입니다.
      </div>
    </>
  );
};

export default CouponAgreementKorean;
